var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 114C91.6142 114 114 91.6142 114 64C114 36.3858 91.6142 14 64 14C36.3858 14 14 36.3858 14 64C14 91.6142 36.3858 114 64 114Z",
    fill: "#F0DB4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4 44.6001H57.1V69.1001C57.1 80.1001 51.8 84.0001 43.4 84.0001C41.3 84.0001 38.7 83.7001 37 83.1001L38 76.0001C39.2 76.4001 40.8 76.7001 42.5 76.7001C46.2 76.7001 48.5 75.0001 48.5 69.1001L48.4 44.6001Z",
    fill: "#323330"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8 74.4C67.1 75.6 70.8 76.8 74.5 76.8C78.5 76.8 80.6 75.1 80.6 72.5C80.6 70.1 78.8 68.7 74.1 67.1C67.7 64.8 63.4 61.2 63.4 55.5C63.4 49 69 44 78.1 44C82.5 44 85.7 44.9 88 46L86 53C84.5 52.3 81.7 51.2 78 51.2C74.2 51.2 72.4 53 72.4 54.9C72.4 57.4 74.5 58.5 79.6 60.4C86.4 62.9 89.6 66.5 89.6 72C89.6 78.5 84.7 84 74 84C69.6 84 65.2 82.8 63 81.6L64.8 74.4Z",
    fill: "#323330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.e886a7835bf1b389efc7eec21a4e96e9.svg";
export { ForwardRef as ReactComponent };